/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Day_WedInputs */

const cs_portals_day_wed = /** @type {(inputs: Portals_Day_WedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`St`)
};

const en_portals_day_wed = /** @type {(inputs: Portals_Day_WedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wed`)
};

/**
* | output |
* | --- |
* | "Wed" |
*
* @param {Portals_Day_WedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_day_wed = /** @type {((inputs?: Portals_Day_WedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Day_WedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_day_wed(inputs)
	return cs_portals_day_wed(inputs)
});